module.exports = __webpack_public_path__ + "static/media/striped_bar_liquidStrip_tall.8ae016b7.svg";